import type { JSX } from 'react';
export const OPERATOR = {
  contains: 'contains',
  doesNotContain: 'doesNotContain',
  endsWith: 'endsWith',
  equal: 'equal',
  greaterThan: 'greaterThan',
  greaterThanInclusive: 'greaterThanInclusive',
  in: 'in',
  isEmpty: 'isEmpty',
  isEven: 'isEven',
  isOdd: 'isOdd',
  lessThan: 'lessThan',
  lessThanInclusive: 'lessThanInclusive',
  notEmpty: 'notEmpty',
  notEqual: 'notEqual',
  notIn: 'notIn',
  segment: 'segment',
  startsWith: 'startsWith',
  variantSchema: 'variantSchema',
} as const;

export const OPERATORS: { label: string | JSX.Element; type: string[]; value: string }[] = [
  { label: 'es igual a', type: ['string', 'number', 'boolean', 'date'], value: OPERATOR.equal },
  {
    label: 'no es igual a',
    type: ['string', 'number', 'boolean', 'date'],
    value: OPERATOR.notEqual,
  },
  { label: 'es menor que', type: ['number', 'date'], value: OPERATOR.lessThan },
  {
    label: 'es menor o igual que',
    type: ['number', 'date'],
    value: OPERATOR.lessThanInclusive,
  },
  { label: 'es mayor que', type: ['number', 'date'], value: OPERATOR.greaterThan },
  {
    label: 'es mayor o igual que',
    type: ['number', 'date'],
    value: OPERATOR.greaterThanInclusive,
  },
  { label: 'está en la lista', type: ['string'], value: OPERATOR.in },
  { label: 'no está en la lista', type: ['string'], value: OPERATOR.notIn },
  { label: 'contiene', type: ['array'], value: OPERATOR.contains },
  { label: 'no contiene', type: ['array'], value: OPERATOR.doesNotContain },
  { label: 'es par', type: ['number'], value: OPERATOR.isEven },
  { label: 'es impar', type: ['number'], value: OPERATOR.isOdd },
  { label: 'comienza con', type: ['string', 'number'], value: OPERATOR.startsWith },
  { label: 'termina con', type: ['string', 'number'], value: OPERATOR.endsWith },
  {
    label: 'está vacío',
    type: ['string', 'number', 'boolean', 'date', 'array'],
    value: OPERATOR.isEmpty,
  },
  {
    label: 'no está vacío',
    type: ['string', 'number', 'boolean', 'date', 'array'],
    value: OPERATOR.notEmpty,
  },
  { label: 'está en el segmento', type: ['string', 'number'], value: OPERATOR.segment },
  { label: 'variantes', type: ['string', 'number'], value: OPERATOR.variantSchema },
];

export const LOGICAL_OPERATOR_LABELS: Record<string, string> = {
  all: 'todas',
  any: 'cualquiera',
  not: 'no se cumple',
};
